var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1140_6916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0001C25 31.3269 39.3269 17 57 17C74.6731 17 89 31.3269 89 49.0001C89 66.6732 74.6731 81.0001 57 81.0001C39.3269 81.0001 25 66.6732 25 49.0001Z",
    fill: "#610ECD",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 49.0001C25 31.3269 39.3269 17 57 17C74.6731 17 89 31.3269 89 49.0001C89 66.6732 74.6731 81.0001 57 81.0001C39.3269 81.0001 25 66.6732 25 49.0001Z",
    fill: "url(#paint0_linear_1140_6916)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57 16.5C74.9492 16.5 89.5 31.0508 89.5 49C89.5 66.9493 74.9493 81.5 57 81.5C39.0507 81.5 24.5 66.9493 24.5 49C24.5 31.0508 39.0508 16.5 57 16.5Z",
    stroke: "#D9CDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3594 42.1667H54.333C54.79 42.1668 55.1658 42.5428 55.166 42.9998V47.4998H51.666C50.8434 47.4999 50.1662 48.1772 50.166 48.9998C50.166 49.8225 50.8433 50.4997 51.666 50.4998H55.166V54.9998C55.166 55.4569 54.7901 55.8337 54.333 55.8337H51C49.2307 55.8337 47.6234 55.1577 46.4033 54.0574L46.165 53.8318C45.0587 52.7248 44.335 51.2477 44.1875 49.6033L44.166 49.2722C44.0193 45.3998 47.413 42.1668 51.3594 42.1667Z",
    fill: "#FBFAFF",
    stroke: "#EBE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.666 42.1667H63C64.7691 42.1668 66.3757 42.8428 67.5957 43.9431L67.835 44.1687C68.9307 45.2778 69.6616 46.7548 69.7998 48.3943L69.8203 48.7244V48.7273C69.9806 52.5991 66.5873 55.8337 62.6396 55.8337H59.666C59.209 55.8336 58.833 55.4568 58.833 54.9998V50.4998H62.333C63.1558 50.4998 63.833 49.8226 63.833 48.9998C63.8328 48.1771 63.1557 47.4998 62.333 47.4998H58.833V42.9998L58.8369 42.9158C58.8797 42.4976 59.2374 42.1669 59.666 42.1667Z",
    fill: "#FBFAFF",
    stroke: "#EBE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3337 48H55.667V50H58.3337V48Z",
    fill: "#FBFAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1140_6916",
    x: 0,
    y: 0,
    width: 114,
    height: 114,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.37398 0 0 0 0 0.193943 0 0 0 0 0.607543 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1140_6916"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1140_6916",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1140_6916",
    x1: 25,
    y1: 17,
    x2: 89.0001,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#DB6704",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DB6704",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/ShareLink.3ba19525991a1d1aa55173504dc385ed.svg";
export { ForwardRef as ReactComponent };